<template>
  <Button v-if="!isElectron()" class="px-16" color="text-b-w" @click="handleScan"><slot /> </Button>
</template>

<script setup lang="ts">
  import { useDeviceStore, useLocaleStore } from '@/stores'
  import { isElectron } from '@/utils/env'
  import Button from '@rapoo/element/components/ui/button/Button.vue'

  const deviceStore = useDeviceStore()
  const { t } = useLocaleStore()

  const handleScan = () => {
    deviceStore.scan()
  }
</script>
